// schema-issue-summary.ts
//
// Review P4 L2 (2026-10-01): a proposal rejected by a schema used to carry
// zod's multi-line JSON error, whose length the WORKER chose (one entry per
// unknown key it sent). That text lands in the journal receipt (`remote_id`)
// and in the operator's escalation message — so it is one line per issue,
// `path: message`, control characters blanked, capped by code point. zod 4
// issues carry no field VALUES, but unknown-key messages do quote the key names
// the worker sent — hence the control-character filter.
import type { z } from "zod";

const MAX_REASON_CHARS = 500;

export function summarizeSchemaIssues(error: z.ZodError): string {
  const text = error.issues
    .map((issue) => `${issue.path.join(".") || "(gốc)"}: ${issue.message}`)
    .join("; ")
    // biome-ignore lint/suspicious/noControlCharactersInRegex: blanking them is the point
    .replace(/[\u0000-\u001f\u007f\s]+/g, " ");
  const chars = Array.from(text);
  return chars.length > MAX_REASON_CHARS ? `${chars.slice(0, MAX_REASON_CHARS).join("")}…` : text;
}
